var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1185 8.6623L23.0435 8.60605L12.9747 3.2998C12.3747 2.9248 11.6247 2.9248 11.0435 3.2998L0.955991 8.60605L0.880991 8.6623C0.505991 8.9248 0.430991 9.43105 0.693491 9.80605C0.955991 10.1623 1.44349 10.2561 1.81849 10.0123L3.82474 8.9623V19.6873C3.82474 20.3998 4.40599 20.9998 5.13724 20.9998H18.8997C19.6122 20.9998 20.2122 20.4186 20.2122 19.6873V8.94355L22.2185 9.99355C22.3497 10.0873 22.5185 10.1248 22.6685 10.1248C22.931 10.1248 23.1747 10.0123 23.3247 9.7873C23.5685 9.43105 23.4935 8.9248 23.1185 8.6623ZM18.5622 19.3498H5.43724V8.08105L11.8122 4.7248L11.8872 4.6873C11.9435 4.6498 12.0185 4.6498 12.0747 4.6873L12.1122 4.70605L18.5435 8.08105V19.3498H18.5622Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 9.95644V13.4064C8.8877 14.0252 9.11269 14.5877 9.52519 15.0377C10.2002 15.7502 10.9877 16.3502 11.8502 16.8189L12.0002 16.8939L12.1502 16.8189C13.0127 16.3502 13.8002 15.7502 14.4752 15.0377C14.8877 14.5877 15.1127 14.0252 15.1127 13.4064V9.95644L12.0002 9.2627L8.8877 9.95644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/Insurance.546c3c838cda0eadf80a863bebbffe25.svg";
export { ForwardRef as ReactComponent };